<template>
    <div v-if="replyCommentDialog">
        <v-overlay>
            <div class="overlay_content">
                <div class="content">
                    <div class="mt-2">
                        <v-container>
                            <v-row>
                                <v-col cols="1" class="avatar">
                                    <img :src="userData.user.image?userData.user.image.thumbnail:image" class="user_img" />
                                </v-col>
                                <v-col cols="7">
                                    <div class="name">
                                        <v-row>
                                            <label
                                                class="--font"
                                                style="font-weight: 500"
                                            >
                                               {{userData.user.full_name}}
                                                <!-- <h1>HELLO</h1> -->
                                            </label>
                                        </v-row>
                                        <v-row>
                                            <small
                                                class="secondary-font lowerText"
                                            >
                                               
                                                <time-ago
                                            :datetime="userData.created_at"
                                           
                                    />
                                               
                                            </small>
                                        </v-row>
                                    </div>
                                </v-col>
                                <v-spacer />
                                <v-col>
                                    <div class="flex">
                                        <div v-for="i in userData.rating" :key="i">
                                            <v-icon size="16" color="#30A46C">
                                                mdi-star</v-icon
                                            >
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <div>
                                <p class="--font comment_desc">
                                   {{userData.review}}
                                </p>
                            </div>
                        </v-container>
                    </div>
                    <!-- <div>
                        <v-text-field
                            class="search-input"
                            filled
                            light
                            outlined
                            hide-details
                            v-model="commentTest"
                            placeholder="Add a comment.."
                            background-color="#F6F9F6"
                            append-icon="mdi-send"
                        ></v-text-field>
                    </div> -->
                </div>
                <div>
                    <button
                        class="close_button"
                        @click="replyCommentDialog = !replyCommentDialog"
                    >
                        Close
                    </button>
                </div>
            </div>
        </v-overlay>
    </div>
</template>

<script>
import {TimeAgo} from 'vue2-timeago'
export default {
    name: "replyComment",
    data() {
        return {
            replyCommentDialog: false,
            image: require("../../../../assets/DummyAvatar.png"),
            data:null
           
        };
    },
   
    props:{
        userData:{
            type:Object
        },
        
    },
    components:{
       "time-ago": TimeAgo
    }
};
</script>

<style scoped>
.overlay_content {
    margin: auto;
    padding: auto;
    position: relative;
    top: 25%; /* 25% from the top */
    width: 100%; /* 100% width */
    text-align: center; /* Centered text/links */
}
.content {
    background-color: white;
    width: 500px;
    padding: 1rem;
}
.user_img {
    height: 40px;
    width: 40px;
    transform: translateY(-10px);
    object-fit: cover;
}
.name {
    margin-left: 2rem;
}
.comment_desc {
    text-align: left;
    font-size: 16px;
}
.close_button {
    background-color: white;
    color: #000;
    padding: 1rem;
    margin-top: 1rem;
    width: 200px !important;
    border-radius: 30px;
}
.edit_reply_button {
    background-color: #318535;
    width: 100% !important;
    padding: 0.6rem;
    border-radius: 3px;
    margin-bottom: 0.4rem;
}
.search-input fieldset {
    color: white !important;
}
</style>